import { FundRuleCondition } from './fund-rule-condition';
import { User } from './user';

export class FundRule {
  rule_name!: string;
  rule_description!: string;
  is_modifier!: boolean;
  modifier_number?: string;
  priority?: number;
  modifier_code?: string;
  parameter_name!: string;
  parameter_comparator!: string;
  parameter_value!: string;
  action!: string;
  action_percentage?: number;
  status!: string;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  required_conditions?: Array<FundRuleCondition>;
  optional_conditions?: Array<FundRuleCondition>;

  getReadableName() {
    return this.is_modifier ? '#' + this.modifier_number : this.rule_name;
  }

  constructor(data: any) {
    this.rule_name = data.rule_name;
    this.rule_description = data.rule_description;
    this.is_modifier = data.is_modifier;
    this.modifier_number = data.modifier_number;
    this.priority = data.priority;
    this.priority = data.priority;
    this.modifier_code = data.modifier_code;
    this.parameter_name = data.parameter_name;
    this.parameter_comparator = data.parameter_comparator;
    this.parameter_value = data.parameter_value;
    this.action = data.action;
    this.action_percentage = data.action_percentage;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }


    if (data.optional_conditions) {
      this.optional_conditions = data.optional_conditions.map((el: any) => new FundRuleCondition(el));
    }
    if (data.required_conditions) {
      this.required_conditions = data.required_conditions.map((el: any) => new FundRuleCondition(el));
    }
  }
}
